module.exports = __webpack_public_path__ + "img/3.85739388.jpg";